import React, { Component } from 'react';
import { Form, Checkbox, Spin, Card, Button } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Container,
  formLayout,
  formValidateMessages,
  FormWrapper,
  Modal,
  SecondaryButton,
  PrimaryButtonV2,
  SpaceBetween,
  TipBox,
  FileUploader,
  AddModal,
  addMetaData,
} from 'utils';
import './RichTextCss.css';
import { ProjectsActions } from 'redux/actions';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import ProjectPageTest from 'scenes/Project/v2/ProjectPage';
import PrivateRoute from 'PrivateRoute';
import { MemoryRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { SubmissionIcon } from 'images';
import styled from '@emotion/styled/macro';

const TitleLable = styled.div`
  font-size: 24px;
  font-wight: 600;
  margin-left: 20px;
  margin-top: 24px;
`;

const AddTitle = styled.div`
  font-size: 18px;
  font-wight: 600;
  padding-bottom: 16px;
`;

const DocumentUploadSection = styled.section`
  margin: 32px 0;

  h2 {
    margin-bottom: 12px;
  }

  p {
    margin-bottom: 20px;
  }
`;

const UploadDocumentsButton = styled.button`
  min-width: 260px;
  height: 44px;
  padding: 0 16px;
  border: 2px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #181d27;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

const FormItem = Form.Item;
class ContractDocuments extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    projectId: PropTypes.string,
    errors: PropTypes.object.isRequired,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    mobileFormShow: PropTypes.bool.isRequired,
    submitDraft: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
    handleSubmission: PropTypes.func.isRequired,
    missingPages: PropTypes.array,
    handleOnChange: PropTypes.func,
    uploadFiles: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.project?.contractDocuments?.paypal_check, // New state for the input field value
      showPreviewModal: false,
      showFileUploader: false,
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange = (e) => {
    this.setState({ value: e.target.value });
  };

  // handleInputChange = (e) => {
  //   e.target.value = e.target.value
  //     .replace(/[^\dA-Z]/g, '')
  //     .replace(/(.{4})/g, '$1 ')
  //     .trim();
  // };
  onFinish = (values) => {
    const {
      updateDraft,
      projectId,
      currentStep,
      setCanMove,
      showModal,
      selectedStep,
      setSubmitFromModal,
      editProject,
      project,
    } = this.props;

    this.handleClosePreviewModal();

    if (editProject) {
      this.onSubmit();
      return;
    }

    const metaData = addMetaData(project);

    if (metaData) {
      values = { ...values, meta_data: metaData };
    }

    let vals = {
      ...values,
      initiator_birthday: '1990-01-01T00:00:00.000Z',
      initiator_phone_number: '000000000000',
      initiator_building_number: '0',
      initiator_zip_code: '00000',
      initiator_nationality: 'none',
      goal_explanation: 'none',
    };

    if (!project.fundingTarget.goal) {
      vals = { ...vals, goal: '100' };
    }

    if (showModal) {
      updateDraft(
        projectId,
        {
          ...vals,
          terms_1: vals.terms,
          terms_2: vals.guidelines,
          terms_3: vals.bestätige,
          terms_4: vals.myDate,
        },
        selectedStep - 1
      );
      setSubmitFromModal(false);
    } else {
      updateDraft(
        projectId,
        {
          ...vals,
          terms_1: vals.terms,
          terms_2: vals.guidelines,
          terms_3: vals.bestätige,
          terms_4: vals.myDate,
        },
        currentStep
      );
    }

    setCanMove(true);
    this.props.handleSteps(9);
  };

  onSubmit = () => {
    this.handleClosePreviewModal();
    if (this.props.editProject && this.props.projectId)
      this.props.handleSubmission();
  };

  onReturn = () => {
    if (this.props.editProject) {
      this.props.handleExitEditForm();
    }
    else {
      this.props.handleSteps(19);
    }
  };

  onProjectPreview = () => {
    if (this.props.projectId) {
      this.setState({ showPreviewModal: true });
    }
  };

  handleClosePreviewModal = () => {
    this.setState({ showPreviewModal: false });
  };

  handleShowFileUploader = () => this.setState({ showFileUploader: true });
  handleHideFileUploader = () => this.setState({ showFileUploader: false });

  render() {
    const {
      project,
      loading,
      setCanMove,
      projectId,
      mobileFormShow,
      editProject,
      missingPages,
      uploadFiles,
    } = this.props;

    const { showFileUploader } = this.state;

    return (
      <Container className="" style={{maxWidth: 600}}>
        <Spin spinning={loading}>
          <h1>Projekt einreichen</h1>

          <p>
            Damit dein Projekt erfolgreich auf commonsplace starten kann,
            bestätige bitte die folgenden Punkte.
          </p>

          <p>
            Optional kannst du zusätzlich Dokumente hochladen, die dein Projekt
            transparenter und vertrauenswürdiger machen.
          </p>

          <p style={{ color: '#3F621A', fontWeight: 600 }}>
            Bei Fragen lies dir gerne die FAQs durch oder kontaktiere uns{' '}
            <a
              href="/faqs"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              hier.
            </a>
          </p>

          <DocumentUploadSection>
            <h2>Hinweis zu den Dokumenten:</h2>
            <p>
              Optional kannst du hier Unterlagen hochladen, die die
              Vertrauenswürdigkeit deines Projekts stärken. Diese Dokumente
              sind nur für das commonsplace-Team sichtbar und helfen uns bei
              der Prüfung.
            </p>
            <UploadDocumentsButton
              type="button"
              onClick={this.handleShowFileUploader}
            >
              Unterlagen hochladen (optional)
            </UploadDocumentsButton>
          </DocumentUploadSection>

          {!loading && (
            <Form
              {...formLayout}
              name="project-details"
              onFinish={this.onFinish}
              onChange={() => setCanMove(false)}
              validateMessages={formValidateMessages}
              initialValues={
                projectId
                  ? project
                    ? {
                        ...project.contractDocuments,
                      }
                    : {
                        terms: false,
                        myDate: false,
                        guidelines: false,
                        bestätige: false,
                      }
                  : {
                      terms: false,
                      myDate: false,
                      guidelines: false,
                      bestätige: false,
                    }
              }
            >
              <FormWrapper>
                <>
                  <h2>Bitte bestätige folgende Punkte:</h2>
                  <FormItem
                    name="terms"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        transform: (value) => value || undefined, // Those two lines
                        type: 'boolean', // Do the magic
                        message:
                          'Bitte stimme den Nutzungsbedingungen und den Gebühren zu.',
                      },
                    ]}
                  >
                    <Checkbox checked={true} disabled={editProject}>
                      Ich stimme den{' '}
                      <a
                        href="/guidelines"
                        style={{
                          color: '#3F621A',
                          textDecoration: 'underline',
                        }}
                      >
                        ANB
                      </a>{' '}
                      und den{' '}
                      <a
                        href="/guidelines"
                        style={{
                          color: '#3F621A',
                          textDecoration: 'underline',
                        }}
                      >
                        Gebühren
                      </a>{' '}
                      zu.
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="guidelines"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        transform: (value) => value || undefined, // Those two lines
                        type: 'boolean', // Do the magic
                        message:
                          'Bitte bestätige, dass dein Projekt die Regeln erfüllt.',
                      },
                    ]}
                  >
                    <Checkbox checked={true} disabled={editProject}>
                      Mein Projekt erfüllt die{' '}
                      <a
                        href="/guidelines"
                        style={{
                          color: '#3F621A',
                          textDecoration: 'underline',
                        }}
                      >
                        Richtlinien.
                      </a>
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="bestätige"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        transform: (value) => value || undefined,
                        type: 'boolean',
                        message:
                          'Bitte bestätige, dass wir deine Daten an Stripe übermitteln dürfen.',
                      },
                    ]}
                  >
                    <Checkbox checked={true} disabled={editProject}>
                      Ich bestätige, dass meine Daten an unseren Zahlungspartner
                      Stripe zur Legitimation weitergegeben werden dürfen.
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="myDate"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        transform: (value) => value || undefined,
                        type: 'boolean',
                        message:
                          'Du musst der Einverständniserklärung zustimmen, um weiter machen zu können.',
                      },
                    ]}
                  >
                    <Checkbox checked={true} disabled={editProject}>
                      Ich erkläre hiermit, dass die Angaben in diesem Antrag und
                      allen beigefügten Anlagen richtig und vollständig sind.
                      Ich werde die commonplace-Community unverzüglich über alle
                      relevanten Änderungen informieren. Ich bin einverstanden,
                      dass meine persönlichen Daten von commonplace gespeichert
                      und verarbeitet werden – auch zu Zwecken der Begutachtung,
                      Statistik und Evaluation. Im Fall der Bewilligung stimme
                      ich zu, dass die angegebenen Daten veröffentlicht werden
                      dürfen. Mir ist bewusst, dass commonplace meinen Antrag
                      ohne Angabe von Gründen ablehnen kann.
                    </Checkbox>
                  </FormItem>
                </>
              </FormWrapper>

              {editProject && (
                <>
                  {missingPages?.length > 0 ? (
                    <TipBox>
                      <img
                        style={{
                          width: '32px',
                          margin: '16px',
                          alignSelf: 'flex-start',
                        }}
                        src={SubmissionIcon}
                        alt="Submission icon"
                      />
                      <p
                        style={{
                          paddingTop: '16px',
                          paddingRight: '16px',
                          fontSize: '14px',
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          Du kannst dein Projekt nicht einreichen, da noch
                          Pflichtangaben auf folgenden Seiten fehlen:
                        </span>{' '}
                        <br />
                        <ul style={{ paddingLeft: '20px' }}>
                          {missingPages.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </p>
                    </TipBox>
                  ) : (
                    <TipBox>
                      <img
                        style={{
                          width: '32px',
                          margin: '16px',
                          alignSelf: 'flex-start',
                        }}
                        src={SubmissionIcon}
                        alt="Submission icon"
                      />
                      <p
                        style={{
                          paddingTop: '16px',
                          paddingRight: '16px',
                          fontSize: '14px',
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          Überprüfung nach Änderungen erforderlich
                        </span>{' '}
                        <br />
                        Dein Projekt ist bereits live. Wenn du es mit geänderten
                        Angaben erneut einreichst, bleibt die aktuelle Version
                        online, bis die Überprüfung abgeschlossen ist. Dies kann
                        bis zu 24 Stunden dauern.
                      </p>
                    </TipBox>
                  )}
                </>
              )}

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.onReturn}
                  >
                    {editProject ? (
                      <p>Zurück zur Projektübersicht</p>
                    ) : (
                      <>
                        <ArrowLeftOutlined />
                        <p>Zurück</p>
                      </>
                    )}
                  </SecondaryButton>

                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {!mobileFormShow && (
                      <PrimaryButtonV2
                        primary={true}
                        minWidth="163px"
                        onClick={this.onProjectPreview}
                        style={{ marginRight: '24px' }}
                      >
                        <p>Projektvorschau</p>
                      </PrimaryButtonV2>
                    )}
                    <PrimaryButtonV2
                      type="primary"
                      htmltype="submit"
                      minWidth="177px"
                      id="submit-button"
                      disabled={missingPages?.length > 0}
                    >
                      {editProject ? (
                        <p>Projekt einreichen</p>
                      ) : (
                        <>
                          <p>Zum letzten Schritt </p>
                          <ArrowRightOutlined />
                        </>
                      )}
                    </PrimaryButtonV2>
                  </div>
                </SpaceBetween>
                {mobileFormShow && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      width: '100%',
                      marginTop: '12px',
                    }}
                  >
                    <PrimaryButtonV2
                      primary={true}
                      minWidth="163px"
                      onClick={this.onProjectPreview}
                    >
                      <p>Projektvorschau</p>
                    </PrimaryButtonV2>
                  </div>
                )}
              </FormItem>
            </Form>
          )}

          <Modal
            showModal={this.state.showPreviewModal}
            handelCloseModal={this.handleClosePreviewModal}
            width="90%"
          >
            <MemoryRouter initialEntries={[`/view/${projectId}`]}>
              <PrivateRoute
                exact
                path={`/view/:id`}
                component={ProjectPageTest}
              />
            </MemoryRouter>
          </Modal>
          <AddModal
            showModal={showFileUploader}
            handelCloseModal={this.handleHideFileUploader}
            title={
              <TitleLable>Unterstützende Unterlagen (optional)</TitleLable>
            }
            width="65%"
          >
            <AddTitle>Vertrauen ist uns wichtig!</AddTitle>
            <p>
              Lade hier unterstützende Unterlagen hoch, um die Kuratierung und
              Glaubwürdigkeit deines Projekts zu stärken.
            </p>
            <p>
              Die Dokumente gehen nur an das commonsplace-Team, werden
              vertraulich bewahrt.
            </p>
            <p>Unterlagen können z. B. sein:</p>
            <ul>
              <li>Bilder vom Wirkungsort</li>
              <li>Budgetpläne oder Finanzübersichten</li>
              <li>Bestätigungsschreiben von Partnern oder Organisationen</li>
              <li>
                Weitere Nachweise, die dein Projekt und seine Validität stärken
              </li>
              <li>usw.</li>
            </ul>
            <p>
              Falls du diese Unterlagen jetzt nicht hochlädst, kann es sein,
              dass wir sie später im Prüfungsprozess von dir anfordern.
            </p>

            <Card style={{ background: '#fafafa' }}>
              {(project.supportDocuments || []).length > 0 ? (
                <div style={{ marginTop: 16 }}>
                  <h4>Hochgeladene Dateien</h4>
                  <ul style={{ listStyle: 'none', padding: 0 }}>
                    {(project.supportDocuments || []).map((file) => (
                      <li
                        key={file.filename}
                        style={{
                          marginBottom: 10,
                          padding: '10px',
                          border: '1px solid #e5e5e5',
                          borderRadius: 4,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          <strong>{file.filename}</strong>
                          <div style={{ fontSize: '0.85em', color: '#888' }}>
                            {(file.byte_size / 1024).toFixed(1)} KB
                          </div>
                        </div>
                        <Button
                          type="primary"
                          ghost
                          size="small"
                          onClick={() => window.open(file.url, '_blank')}
                        >
                          Download
                        </Button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <h4 style={{ margin: 0 }}>Keine hochgeladenen Dokumente</h4>
              )}
            </Card>

            <FileUploader
              projectId={project.id}
              uploadFiles={uploadFiles}
              closeModal={this.handleHideFileUploader}
            />
            <ul style={{ marginTop: 24 }}>
              <li>Zulässige Formate: PDF, JPG, PNG, DOCX</li>
              <li>Max. Dateigröße: 1 MB</li>
              <li>Max. 5 Dokumente</li>
            </ul>
            <p style={{ marginTop: 24 }}>
              Hinweis: Diese Unterlagen sind nicht öffentlich sichtbar und
              dienen ausschließlich der internen Prüfung und Kuratierung deines
              Projektes.
            </p>
          </AddModal>
        </Spin>
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep, handleInput } = state.projects;
  return {
    project,
    loading,
    errors,
    currentStep,
    handleInput,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
  submitDraft: (projectId) => dispatch(ProjectsActions.submitDraft(projectId)),
  uploadFiles: (projectId, formData) =>
    dispatch(ProjectsActions.uploadFiles(projectId, formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractDocuments);
